import { Resources } from 'constants/resources';

import { usePermissions } from 'hooks/usePermissions';
import { useRecordModal } from 'hooks/useRecordModal';
import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { Alert } from 'shared/mui/Alert/Alert';
import { CreateButton } from 'shared/mui/Buttons';
import {
  ContextMenu,
  ContextMenuDeleteButton,
  ContextMenuEditButton,
  ContextMenuShowButton,
} from 'shared/mui/ContextMenu';
import { DateTimeField, TextField, TextLinkField } from 'shared/react-admin/Fields';
import { ListPage } from 'shared/react-admin/Pages';
import { Permission } from 'types/embedded/permission';
import { Referral } from 'types/embedded/referral';

import { ReferralsDeleteDialog } from './components/ReferralsDeleteDialog';
import { DatagridStyled } from './ReferralsList.styled';

export const ReferralsList: React.FC = () => {
  const translate = useTypedTranslate();
  const { hasResourcePermissions } = usePermissions();
  const {
    record: recordDelete,
    handleOpenRecordModal: handleOpenRecordModalDelete,
    openRecordModal: openRecordModalDelete,
    handleCloseRecordModal: handleCloseRecordModalDelete,
  } = useRecordModal<Referral>();

  return (
    <ListPage
      actions={[
        hasResourcePermissions(Resources.Referrals, [Permission.Full, Permission.Create]) && (
          <CreateButton key="referrals" />
        ),
      ]}
      empty={<Alert severity="info">{translate('app.referrals.emptyAlert')}</Alert>}
      headerTitle={{
        titleText: translate('app.referrals.title'),
      }}
      sort={{ field: 'id', order: 'DESC' }}
    >
      <DatagridStyled bulkActionButtons={false}>
        <TextField label="ID" sortBy="id" source="originId" />
        <TextField label={translate('app.referrals.refId')} source="refId" />
        <TextLinkField
          label={translate('app.table.name')}
          resource={Resources.Referrals}
          source="name"
          type="show"
        />
        <DateTimeField label={translate('app.table.createdAt')} source="createdAt" />
        <DateTimeField label={translate('app.table.updatedAt')} source="updatedAt" />
        <ContextMenu
          render={(record: Referral) => [
            <ContextMenuShowButton key="show-button" />,
            <ContextMenuEditButton key="edit-button" />,
            hasResourcePermissions(Resources.Companies, [Permission.Full, Permission.Delete]) && (
              <ContextMenuDeleteButton
                key="delete-button"
                onClick={() => handleOpenRecordModalDelete(record)}
              />
            ),
          ]}
        />
      </DatagridStyled>
      {openRecordModalDelete && (
        <ReferralsDeleteDialog
          onClose={handleCloseRecordModalDelete}
          open={openRecordModalDelete}
          record={recordDelete}
        />
      )}
    </ListPage>
  );
};
